import { render, staticRenderFns } from "./UserReportStackChart.vue?vue&type=template&id=66ce132c&scoped=true&"
import script from "./UserReportStackChart.vue?vue&type=script&lang=js&"
export * from "./UserReportStackChart.vue?vue&type=script&lang=js&"
import style0 from "./UserReportStackChart.vue?vue&type=style&index=0&id=66ce132c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce132c",
  null
  
)

export default component.exports